import { cloneDeep } from 'lodash'
import * as localApi from '@api/api-routes'
import * as apiTo from '@/modular-api'

export default {
  namespaced: true,

  state: () => ({
    subscription: null,
    periodId: null,
    subscriptionPeriods: [],
    users: null
  }),

  getters: {
    periodId(state) {
      if (!state.subscription) return null
      if (state.periodId) return state.periodId
      if (state.subscription.next) return state.subscription.next.id
      else if (state.subscription.current) return state.subscription.current.id
      return null
    },
    subscription: state => state.subscription,
    subscriptionPeriods: state => state.subscriptionPeriods
  },

  mutations: {
    setSubscription: (state, payload) => (state.subscription = payload),
    setUsers: (state, payload) => (state.users = payload),
    setPeriodId: (state, id) => (state.periodId = id),
    setSubscriptionPeriods: (state, payload) => (state.subscriptionPeriods = payload),
    addPeriod: (state, payload) => state.subscriptionPeriods.push(payload),
    updatePeriod(state, payload) {
      const index = state.subscriptionPeriods.findIndex(period => period.id === payload.id)
      if (~index) {
        state.subscriptionPeriods.splice(index, 1, payload)
      }
      let subscription = cloneDeep(state.subscription)
      const periodToUpdate = getWhichPeriodMatchesId(subscription, payload.id)

      if (periodToUpdate) {
        state.subscription = updateAndGetSubscription(periodToUpdate, subscription, payload)
      }
    },
    updatePeriodPrices(state, payload) {
      /* used when price entry table gets updated in sub show */
      let subscription = cloneDeep(state.subscription)
      const periodToUpdate = getWhichPeriodMatchesId(subscription, payload.id)

      if (periodToUpdate) {
        subscription[periodToUpdate].price = payload.price
        subscription[periodToUpdate].list_price = payload.list_price
        subscription[periodToUpdate].forecasted_price = payload.forecasted_price
        subscription[periodToUpdate].first_offer_price = payload.first_offer_price
        state.subscription = subscription
      }
      const subPeriod = state.subscriptionPeriods.findIndex(p => p.id === payload.id)
      state.subscriptionPeriods[subPeriod] = {
        ...state.subscriptionPeriods[subPeriod],
        price: payload.price,
        list_price: payload.list_price,
        forecasted_price: payload.forecasted_price,
        first_offer_price: payload.first_offer_price
      }
    },
    updateSubscriptionOneTimePurchase(state, payload) {
      /* used when toggling One time purchase */
      const period = payload.current ? payload.current : payload.next
      const periodIndex = state.subscriptionPeriods.findIndex(p => p.id === period.id)
      state.subscriptionPeriods[periodIndex].one_time_purchase = period.one_time_purchase
      state.subscriptionPeriods[periodIndex].end_date = period.end_date
    },
    deletePeriod(state, id) {
      const index = state.subscriptionPeriods.findIndex(period => period.id === id)
      if (~index) {
        state.subscriptionPeriods.splice(index, 1)
      }
    },
    updateEditableFields(state, { key, payload }) {
      state.subscription[key] = payload[key]
    }
  },

  actions: {
    fetchSubscription({ commit }, subId) {
      return apiTo.GET_SUBSCRIPTION(subId).then(({ data }) => commit('setSubscription', data.result))
    },

    updateSubscription({ commit }, { id, key, payload }) {
      return apiTo
        .MODIFY_SUBSCRIPTION(id, payload)
        .then(({ data: { result: subscription } }) => commit('updateEditableFields', { key, payload: subscription }))
    },

    getAndSetSubscriptionPeriods({ commit }, subId) {
      return localApi
        .getSubscriptionPeriodsWithTaskApplicability(subId)
        .then(({ data }) => commit('setSubscriptionPeriods', data.result))
    },

    getAndSetUsers({ commit }) {
      return apiTo.GET_USERS().then(({ data }) => commit('setUsers', data.result))
    }
  }
}

function getWhichPeriodMatchesId(subscription, id) {
  if (subscription.current && subscription.current.id === id) {
    return 'current'
  } else if (subscription.next && subscription.next.id === id) {
    return 'next'
  }
  return null
}

function updateAndGetSubscription(currentOrNext, subscription, payload) {
  if ((subscription.current && currentOrNext === 'current') || (!subscription.current && currentOrNext === 'next')) {
    subscription.publisher = payload.publisher
    subscription.vendor = payload.vendor
  }
  subscription[currentOrNext].publisher = payload.publisher
  subscription[currentOrNext].vendor = payload.vendor
  subscription[currentOrNext].price = payload.price
  subscription[currentOrNext].list_price = payload.list_price
  subscription[currentOrNext].normalized_price = payload.normalized_price
  subscription[currentOrNext].forecasted_price = payload.forecasted_price
  subscription[currentOrNext].first_offer_price = payload.first_offer_price
  subscription[currentOrNext].name_reference = payload.name_reference
  subscription[currentOrNext].cancellation_deadline = payload.cancellation_deadline
  subscription[currentOrNext].status = payload.status
  return subscription
}
